import React from 'react';
import kebabCase from 'lodash/kebabCase';
import { compose, withState } from 'recompose';
import { Account } from '../../../models/user';
import { Ad } from '../../../components/presentational/Ad';
import AdhesionAd from '../AdhesionAd';
import StickyAcquisition from '../StickyAcquisition';

interface StandardAdhesionProps {
  ad: Ad;
  user: Account;
  section: string;
  hasTimedOut?: boolean;
}

const StandardAdhesion = ({
  ad,
  user,
  section,
  hasTimedOut,
}: StandardAdhesionProps) => {
  // console.log('StandardAdhesion', { ad, user, section, hasTimedOut });
  return (
    <>
      {ad && <AdhesionAd ad={ad} collapsed={hasTimedOut} />}

      <StickyAcquisition
        user={user}
        section={kebabCase(section.toLowerCase())}
        collapsed={!hasTimedOut}
      />
    </>
  );
};

export default compose(withState('hasTimedOut', 'setTimedOut', false))(
  StandardAdhesion
);
